if (window.jQuery){
    (function($){
        $.fn.visible = function(partial){

            var $t        = $(this),
                $w        = $(window),
                viewTop     = $w.scrollTop(),
                viewBottom    = viewTop + $w.height(),
                _top      = $t.offset().top,
                _bottom     = _top + $t.height(),
                compareTop    = partial === true ? _bottom : _top,
                compareBottom = partial === true ? _top : _bottom;

            return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
        };

    })(jQuery);

    window.jQuery(function ($) {

        $(document).scroll(function() {
            var y = $(this).scrollTop();
            if($('#wpadminbar').length){
                $('nav#sticky-genre').addClass('admin');
            }

            if($('#nav-genres').length > 0) {

                if (!$('#nav-genres').visible()) {
                    $('nav#sticky-genre').slideDown();
                    $('#subnav').css('position', 'fixed');
                } else {
                    if ($('nav#sticky-genre').visible()) {
                        $('nav#sticky-genre').slideUp();
                        $('#subnav').css('position', 'absolute');
                    }
                }
            }
        });

    });


}
